import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
})
export class HighlightPipe implements PipeTransform {
  transform(value: any, search: any): any {
    if (!value) {
      return value;
    }

    if (!search) {
      return value;
    }

    const trimmed = search.trim();
    // if (trimmed?.length < 3) {
    //   return value;
    // }

    const safeSearch = this.escapeRegExp(trimmed);
    const regex = new RegExp(safeSearch, 'gi');

    let textToHighlight = value;
    if (trimmed === '/') {
      textToHighlight = value.replace(/<br\s*\/?>/gi, '/&gt;');
    }

    if (!textToHighlight.match(regex)) {
      return value;
    }

    return textToHighlight.replace(
      new RegExp(safeSearch, 'gi'),
      `<span class='app-highlight'>$&</span>`,
    );
  }

  // Escape special regex characters in the search string
  escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
